/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SplitButtonModule } from 'primeng/splitbutton';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { YardLocalComponent } from './yard-local.component';
import { YardLocalContainerComponent } from './data/yard-local-container/yard-local-container.component';
import { YardLocalContainerDataComponent } from './data/yard-local-container/yard-local-container-data/yard-local-container-data.component';
import { YardLocalContainerHeaderComponent } from './data/yard-local-container/yard-local-container-header/yard-local-container-header.component';
import { YardLocalDataComponent } from './data/yard-local-data.component';
import { YardLocalHeaderComponent } from './data/yard-local-header/yard-local-header.component';
import { YardLocalResolver } from './shared/yard-local.resolver';
import { YardLocalRoutingModule } from './yard-local-routing.module';
import { YardLocalService } from './shared/services/yard-local.service';
import { YardLocalSubHeaderComponent } from './data/yard-local-sub-header/yard-local-sub-header.component';

/**
 * @export
 * @class LocoModule
 */
@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        CoreModule,
        OverlayPanelModule,
        DropdownModule,
        AutoCompleteModule,
        InputMaskModule,
        DialogModule,
        SplitButtonModule,
        RadioButtonModule,
        CheckboxModule,
        FormsModule,
        ReactiveFormsModule,
        YardLocalRoutingModule
    ],
    providers: [YardLocalResolver, YardLocalService],
    declarations: [YardLocalComponent, YardLocalDataComponent, YardLocalHeaderComponent, YardLocalSubHeaderComponent, YardLocalContainerComponent, YardLocalContainerHeaderComponent, YardLocalContainerDataComponent],
    exports: [YardLocalComponent]
})
export class YardLocalModule { }
